/* PWA-hazır giriş noktası */
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { initSentry } from "./utils/sentry";

initSentry();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// Service worker registration DISABLED — eski SW'nin cache bug'ı yükleme
// ekranında takılma sorununa yol açıyordu. Yeni public/service-worker.js
// bir "kill switch"; artık YENİ yüklenen kullanıcılar için hiç register
// edilmez ve eskisi çalışıyorsa kendi kendini unregister eder.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    // Eski SW'yi tetiklemek için (unregister flow'unu başlatmak için) bir kez
    // register et — service-worker.js kill switch olduğu için hemen kaldıracak
    navigator.serviceWorker.getRegistrations().then((regs) => {
      // Zaten bir SW kayıtlıysa yeni sürümü yükleyip unregister ettirelim
      if (regs.length > 0) {
        navigator.serviceWorker.register("/service-worker.js").catch(() => {});
      }
    }).catch(() => {});
  });
}
